import styled from "styled-components";
import { CommonCardListWrapper, CommonRechargeCard } from "../../atom";

export const PictureRechargeGiftWrapper = styled.div`
  .card-list-wrapper {
    overflow: hidden;
  }
`;
export const CardListContent = styled.div`
  position: relative;
  .scroll-button {
    position: absolute;
    cursor: pointer;
    top: 0;
    bottom: 0;
    margin: auto 0;
    z-index: 10;
  }

  .left-button {
    left: -30px;
  }

  .right-button {
    right: -30px;
  }
`;
export const PictureRechargeGiftCardList = styled(CommonCardListWrapper)`
  width: max-content;
  padding-right: 10px;
`;

export const PictureRechargeGiftCard = styled(CommonRechargeCard)`
  .extra-welfare {
    flex: 1 1 0%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;
